import { render, staticRenderFns } from "./AnalysisAnswerScore.vue?vue&type=template&id=5f1b6f2a&scoped=true"
import script from "./AnalysisAnswerScore.vue?vue&type=script&lang=js"
export * from "./AnalysisAnswerScore.vue?vue&type=script&lang=js"
import style0 from "./AnalysisAnswerScore.vue?vue&type=style&index=0&id=5f1b6f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b6f2a",
  null
  
)

export default component.exports